import React from "react";
import { Route, Switch } from "react-router-dom";

import { BusinessAdmins, Admins } from "constants/userRoles";
import { AGREEMENT } from "constants/routes";

import AgreementIndex from "views/Agreement/AgreementIndex";
import AgreementCreate from "views/Agreement/AgreementCreate";
import AgreementEdit from "views/Agreement/AgreementEdit";
import AgreementDetail from "views/Agreement/AgreementDetail/AgreementDetail";
import AgreementInvoiceIndex from "views/Agreement/Invoice/AgreementInvoiceIndex";
import AgreementCreditNoteIndex from "views/Agreement/CreditNote/AgreementCreditNoteIndex";

const AgreementRoutes = () => (
  <Switch>
    <Route exact path={AGREEMENT.INDEX} component={Admins(AgreementIndex)} />
    <Route path={AGREEMENT.CREATE} component={Admins(AgreementCreate)} />
    <Route
      exact
      path={AGREEMENT.SHOW}
      component={BusinessAdmins(AgreementDetail)}
    />
    <Route exact path={AGREEMENT.EDIT} component={Admins(AgreementEdit)} />
    <Route
      exact
      path={AGREEMENT.INVOICE_INDEX}
      component={BusinessAdmins(AgreementInvoiceIndex)}
    />
    <Route
      exact
      path={AGREEMENT.CREDIT_NOTE_INDEX}
      component={BusinessAdmins(AgreementCreditNoteIndex)}
    />
  </Switch>
);

export default AgreementRoutes;
